import React from "react";
import ComingSoon from "../../components/ComingSoon";

const AnalyticsDashboards = () => {
  return (
    <ComingSoon
      title="Analytics & Dashboards"
      description="Comprehensive analytics and interactive dashboards for ESG data visualization and insights."
      icon="📈"
    />
  );
};

export default AnalyticsDashboards; 